import { render } from "./UserMobileNav.vue?vue&type=template&id=5ec869a2"
import script from "./UserMobileNav.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./UserMobileNav.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script